export default __webpack_public_path__ + "static/media/StarFill.8a520423.svg";